<template>
  <div :class="[landscape ? 'content' : 'content-portrait']">
    <Touch :slideHandler="slideHandler">
      <div class="cards" ref="cards" @wheel="wheelHandler($event)">
        <Part1 v-if="cardIndex === 0" :slide-handler="slide" :landscape="landscape"></Part1>
        <Part2 v-else-if="cardIndex === 1" :slide-handler="slide" :landscape="landscape"></Part2>
        <Part3 v-else-if="cardIndex === 2" :slide-handler="slide" :landscape="landscape"></Part3>
      </div>
    </Touch>
  </div>
</template>

<script>
import Part1 from './Detail/Part1.vue'
import Part2 from './Detail/Part2.vue'
import Part3 from './Detail/Part3.vue'
import Touch from './Touch.vue'
export default {
  data () {
    return {
      bgIn: {
        classes: 'fadeInLeft',
        delay: 400
      },
      logoIn: {
        classes: 'fadeInLeft',
        delay: 400
      },
      textIn: {
        classes: 'fadeInLeft',
        delay: 400
      },
      cardIndex: -1,
      blockScroll: false
    }
  },
  props: ['landscape'],
  components: {
    Part1,
    Part2,
    Part3,
    Touch
  },
  created () {
    this.cardIndex = parseInt(this.$route.params.id)
  },
  methods: {
    wheelHandler: function (event) {
      if (event.deltaX > 0 || event.deltaY > 0) {
        if (this.cardIndex < 2) {
          if (!this.blockScroll) {
            this.blockScroll = true
            this.slide(1)
          }
        }
      } else {
        if (this.cardIndex > 0) {
          if (!this.blockScroll) {
            this.blockScroll = true
            this.slide(-1)
          }
        }
      }
    },
    slide: function (direct) {
      const self = this
      const delay = this.landscape ? 1500 : 500
      this.cardIndex += direct
      setTimeout(() => {
        self.blockScroll = false
      }, delay)
      const id = parseInt(this.$route.params.id)
      this.$router.push({name: 'Detail', params: {id: id + direct}})
    },
    slideHandler: function (direction) {
      if (direction < 0) {
        if (this.cardIndex < 2) {
          this.slide(1)
        }
      } else {
        if (this.cardIndex > 0) {
          this.slide(-1)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../Global.scss';
.content {
  height: 6rem;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.content-portrait {
  @extend .content;
  height: 100%;
}
.cards {
  width: 100%;
  height: 100%;
  @include flexBox(row, nowrap, center, center);
}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue